"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingTextButton = void 0;
var storm_ui_1 = require("@amzn/storm-ui");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var StyledIcon = (0, styled_components_1.default)(storm_ui_1.Icon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-right: ", ";\n"], ["\n  padding-right: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.mini;
});
var LoadingTextButton = function (props) {
    var onClickSend = props.onClickSend, isLoading = props.isLoading, isDisabled = props.isDisabled, loadingLabel = props.loadingLabel, sendLabel = props.sendLabel;
    return (react_1.default.createElement(storm_ui_1.TextButton, { onClick: onClickSend, disabled: isDisabled || isLoading },
        isLoading && react_1.default.createElement(StyledIcon, { type: 'spinner' }),
        isLoading ? loadingLabel : sendLabel));
};
exports.LoadingTextButton = LoadingTextButton;
var templateObject_1;
